'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('./_virtual/_rollupPluginBabelHelpers.js');
var UAParser = _interopDefault(require('ua-parser-js'));
var Promise = _interopDefault(require('promise-polyfill'));

var Fingerprint2 = typeof window !== 'undefined' ? require('fingerprintjs2') : /*#__PURE__*/function () {
  function _class() {
    _rollupPluginBabelHelpers.classCallCheck(this, _class);
  }

  _rollupPluginBabelHelpers.createClass(_class, [{
    key: "get",
    value: // eslint-disable-next-line class-methods-use-this
    function get(callback) {
      callback('server fingerprint');
    }
  }]);

  return _class;
}(); // formats language to 'en-US'
// necessary as old versions of safari return language as all lowercase, e.g. 'en-us'

var formatLanguage = function formatLanguage(langCode) {
  if (!langCode) return null;

  var _langCode$split = langCode.split('-'),
      _langCode$split2 = _rollupPluginBabelHelpers.slicedToArray(_langCode$split, 2),
      lang = _langCode$split2[0],
      country = _langCode$split2[1];

  if (!country) return lang;
  return "".concat(lang, "-").concat(country.toUpperCase());
};

var getFingerprint = function getFingerprint() {
  return new Promise(function (resolve) {
    return new Fingerprint2().get(function (result) {
      return resolve(result);
    });
  });
};

var index = new Promise(function (resolve) {
  if ((typeof window === "undefined" ? "undefined" : _rollupPluginBabelHelpers.typeof(window)) !== 'object') {
    console.warn('This module is for client side only'); // eslint-disable-line no-console

    return {};
  }

  return getFingerprint().then(function (browserFingerprint) {
    var _window = window,
        _window$navigator = _window.navigator;
    _window$navigator = _window$navigator === void 0 ? {} : _window$navigator;
    var _window$navigator$lan = _window$navigator.language,
        language = _window$navigator$lan === void 0 ? null : _window$navigator$lan,
        _window$navigator$dev = _window$navigator.deviceMemory,
        deviceMemory = _window$navigator$dev === void 0 ? null : _window$navigator$dev,
        _window$navigator$har = _window$navigator.hardwareConcurrency,
        hardwareConcurrency = _window$navigator$har === void 0 ? null : _window$navigator$har,
        _window$navigator$max = _window$navigator.maxTouchPoints,
        maxTouchPoints = _window$navigator$max === void 0 ? null : _window$navigator$max,
        _window$navigator$con = _window$navigator.connection;
    _window$navigator$con = _window$navigator$con === void 0 ? {} : _window$navigator$con;
    var _window$navigator$con2 = _window$navigator$con.downlink,
        effectiveBandwidth = _window$navigator$con2 === void 0 ? null : _window$navigator$con2,
        _window$navigator$con3 = _window$navigator$con.effectiveType,
        effectiveNetworkType = _window$navigator$con3 === void 0 ? null : _window$navigator$con3,
        _window$screen = _window.screen;
    _window$screen = _window$screen === void 0 ? {} : _window$screen;
    var _window$screen$height = _window$screen.height,
        height = _window$screen$height === void 0 ? null : _window$screen$height,
        _window$screen$width = _window$screen.width,
        width = _window$screen$width === void 0 ? null : _window$screen$width;
    var deviceSizePx = height && width ? "".concat(height, ":").concat(width) : null;

    var _UAParser$getResult = new UAParser().getResult(),
        _UAParser$getResult$b = _UAParser$getResult.browser;

    _UAParser$getResult$b = _UAParser$getResult$b === void 0 ? {} : _UAParser$getResult$b;
    var _UAParser$getResult$b2 = _UAParser$getResult$b.name,
        browserName = _UAParser$getResult$b2 === void 0 ? null : _UAParser$getResult$b2,
        _UAParser$getResult$b3 = _UAParser$getResult$b.version,
        browserVersion = _UAParser$getResult$b3 === void 0 ? null : _UAParser$getResult$b3,
        _UAParser$getResult$o = _UAParser$getResult.os;
    _UAParser$getResult$o = _UAParser$getResult$o === void 0 ? {} : _UAParser$getResult$o;
    var _UAParser$getResult$o2 = _UAParser$getResult$o.name,
        osName = _UAParser$getResult$o2 === void 0 ? null : _UAParser$getResult$o2,
        _UAParser$getResult$o3 = _UAParser$getResult$o.version,
        osVersion = _UAParser$getResult$o3 === void 0 ? null : _UAParser$getResult$o3,
        _UAParser$getResult$d = _UAParser$getResult.device;
    _UAParser$getResult$d = _UAParser$getResult$d === void 0 ? {} : _UAParser$getResult$d;
    var _UAParser$getResult$d2 = _UAParser$getResult$d.type,
        deviceType = _UAParser$getResult$d2 === void 0 ? null : _UAParser$getResult$d2,
        _UAParser$getResult$d3 = _UAParser$getResult$d.model,
        deviceModel = _UAParser$getResult$d3 === void 0 ? null : _UAParser$getResult$d3,
        _UAParser$getResult$d4 = _UAParser$getResult$d.vendor,
        deviceVendor = _UAParser$getResult$d4 === void 0 ? null : _UAParser$getResult$d4;
    return resolve({
      // **** From user agent - not reliable, can be changed by user:
      browser_name: browserName,
      browser_version: browserVersion,
      os_name: osName,
      os_version: osVersion,
      device_type: deviceType,
      device_model: deviceModel,
      device_vendor: deviceVendor,
      // ****
      language: formatLanguage(language),
      // BCP47 language code
      device_size_px: deviceSizePx,
      device_mem_gb: deviceMemory,
      // chrome 63+ only
      device_net_speed_mbps: effectiveBandwidth,
      // chrome 61+ only
      time_offset_mins_to_utc: new Date().getTimezoneOffset(),
      // minutes
      browser_fingerprint: browserFingerprint,
      device_touchpoints: maxTouchPoints,
      // all but safari
      device_net_type: effectiveNetworkType,
      // chrome 61+ only
      device_num_processors: hardwareConcurrency // all but IE

    });
  });
});

exports.default = index;
//# sourceMappingURL=index.js.map
